/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */
import { BaseModule } from './BaseModule';
export class DisplaySize extends BaseModule {
  display!: HTMLDivElement;
  override onCreate() {
    this.display = document.createElement('div');
    Object.assign(this.display.style, this.options.displayStyles);
    if (this.resizer.overlay) {
      this.resizer.overlay.appendChild(this.display);
    }
  }
  override onUpdate() {
    if (!this.display || !this.resizer.img) {
      return;
    }
    const size = this.getCurrentSize();
    this.display.innerHTML = size.join(' &times; ');
    if (size[0] > 120 && size[1] > 30) {
      Object.assign(this.display.style, {
        right: '4px',
        bottom: '4px',
        left: 'auto',
      });
    } else if (this.resizer.img.style.float == 'right') {
      const dispRect = this.display.getBoundingClientRect();
      Object.assign(this.display.style, {
        right: 'auto',
        bottom: `-${dispRect.height + 4}px`,
        left: `-${dispRect.width + 4}px`,
      });
    } else {
      const dispRect = this.display.getBoundingClientRect();
      Object.assign(this.display.style, {
        right: `-${dispRect.width + 4}px`,
        bottom: `-${dispRect.height + 4}px`,
        left: 'auto',
      });
    }
  };
  getCurrentSize = () => {
    if (!this.resizer.img) {
      return [0, 0];
    }
    return [
      this.resizer.img.width,
      Math.round((this.resizer.img.width / this.resizer.img.naturalWidth) * this.resizer.img.naturalHeight),
    ];
  };
}
